export default "__VITE_ASSET__CiEc63sT__"